import Offcanvas from "react-bootstrap/Offcanvas";
import "bootstrap/dist/css/bootstrap.min.css";
import { RxCross2 } from "react-icons/rx";
import { customTextColor } from "../../utils/const";
import SearchCandidateApply from "./SearchCandidateApply";
import CandidateMapCard from "../../components/containers/CandidateMapCard";
import { useEffect, useState } from "react";
import { Pagination } from "@mui/material";
import { getAllCandidate } from "../../redux/candidate/candidateSlice";
import { useDispatch, useSelector } from "react-redux";
import { Box } from "@mui/system";
import {
  applyCandidateOnJob,
  getAppliedCandidateById,
} from "../../redux/jobTimeline/jobTimelineSlice";

function CandidateListApplyDrawer({
  handleClose,
  show,
  jobdata,
  MAX_CANDIDATES,
  setPages,
  page,
}) {
  const [pagination, setPagination] = useState({
    current_page: 1,
    has_next: false,
    has_previous: false,
    next_page: null,
    previous_page: null,
    total_pages: 1,
  });
  const [selectedCandidates, setSelectedCandidates] = useState([]);

  const [searchData, setSearchData] = useState({
    current_location: [],
    work_authorization: [],
    skills: [],
    full_name: "",
  });

  const dispatch = useDispatch();
  const jobtimelineStatus = useSelector((state) => state.jobtimeline.viewStaus);
  const allCandiadate = useSelector((state) => state.candidate.data);
  useEffect(() => {
    let jobID = jobdata?.job_id;
    console.log({ jobID });
    dispatch(getAllCandidate(`page=${page}&job_id=${jobID}`));
  }, [page, jobdata]);

  useEffect(() => {
    if (allCandiadate) {
      setPagination({
        current_page: allCandiadate?.current_page,
        has_next: allCandiadate?.has_next,
        has_previous: allCandiadate?.has_previous,
        next_page: allCandiadate?.next_page,
        previous_page: allCandiadate?.previous_page,
        total_pages: allCandiadate?.total_pages,
      });
    }
  }, [allCandiadate]);

  const handlePageChange = (event, value) => {
    setPages(value);
  };

  const updateSelectedCandidates = (candidateData) => {
    console.log({ candidateData });
    setSelectedCandidates((prev) => {
      const index = prev.findIndex((item) => item.id === candidateData.id);
      console.log({ prev });
      console.log({ index });

      if (index !== -1) {
        // Update existing candidate
        const updated = [...prev];
        console.log({ updated });

        updated[index] = { ...updated[index], ...candidateData };
        return updated;
      } else {
        if (prev.length >= MAX_CANDIDATES) {
          alert(`You can select up to ${MAX_CANDIDATES} candidates only.`);
          return prev; // Do not add new candidate if limit is reached
        }
        // Add new candidate
        return [...prev, candidateData];
      }
    });
  };

  // const updateSelectedCandidates = (candidateData) => {
  //   console.log({ candidateData });

  //   setSelectedCandidates((prev) => {
  //     // Filter out already applied candidates
  //     const newlySelectedCandidates = prev.filter(
  //       (item) => !item.is_job_applied
  //     );

  //     console.log("Newly Selected Candidates:", newlySelectedCandidates.length);
  //     console.log("MAX_CANDIDATES:", MAX_CANDIDATES);

  //     if (candidateData.is_job_applied) {
  //       // Directly update applied candidates
  //       return [...prev, candidateData];
  //     } else if (newlySelectedCandidates.length < MAX_CANDIDATES) {
  //       // Add new candidate only if limit is not reached
  //       return [...prev, candidateData];
  //     } else {
  //       alert(`You can only apply up to ${MAX_CANDIDATES} candidates.`);
  //       return prev;
  //     }
  //   });
  // };

  const handleOnClear = () => {
    setSearchData({
      current_location: [],
      work_authorization: [],
      skills: [],
      full_name: "",
    });
    dispatch(getAllCandidate());
  };

  const handleOnClickApplyJob = () => {
    let values = {
      job_id: jobdata?.job_id,
      candidate_resume_ids: selectedCandidates,
    };
    dispatch(applyCandidateOnJob(values));
  };

  useEffect(() => {
    if (jobtimelineStatus === "apply_candidate_requirement_succsess") {
      let jobID = jobdata?.job_id;
      dispatch(getAppliedCandidateById(jobID));
      dispatch(getAllCandidate(`page=${page}&job_id=${jobID}`));
      handleClose();
    }
  }, [jobtimelineStatus, page]);

  const handleClickOnCross = () => {
    handleOnClear();
    handleClose();
  };

  useEffect(() => {
    if (searchData) {
      const queryParams = Object.keys(searchData).reduce((acc, key) => {
        const value = searchData[key];
        console.log({ value });

        if (Array.isArray(value) && value.length > 0) {
          // Send arrays as JSON strings
          acc[key] = JSON.stringify(value);
        } else if (
          value !== "" &&
          value !== null &&
          value !== undefined &&
          !Array.isArray(value)
        ) {
          // Include non-empty strings or numbers
          acc[key] = value;
        }
        return acc;
      }, {});

      console.log("Filtered Query Params:", queryParams);

      // Convert queryParams into a query string
      const queryString = Object.entries(queryParams)
        .map(
          ([key, value]) =>
            `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
        )
        .join("&");

      console.log("Final Query String:", queryString);

      // Dispatch the action with the query string
      dispatch(getAllCandidate(queryString));
    } else {
      dispatch(getAllCandidate(""));
    }
  }, [searchData]);

  return (
    <Offcanvas
      show={show}
      onHide={handleClose}
      placement="end"
      scroll={false}
      backdrop={false}
      style={{
        border: "none",
        marginTop: "74px",
        width: "40%",
        padding: "0 0 0 10px",
        backgroundColor: "#f9fafb",
        borderLeft: "1px solid #f9fafb",
        boxShadow: "-4px 0 10px rgba(0, 0, 0, 0.1)",
      }}
    >
      <Offcanvas.Header
        style={{
          display: "flex",
          alignItems: "center",
        }}
      >
        <SearchCandidateApply
          setSearchData={setSearchData}
          searchData={searchData}
        />
        <RxCross2
          style={{
            fontSize: "22px",
            cursor: "pointer",
            marginLeft: "30px",
            color: customTextColor,
          }}
          onClick={handleClickOnCross}
        />
      </Offcanvas.Header>
      <Offcanvas.Body>
        {allCandiadate?.profiles?.map((candidate, index) => {
          const selectedCandidate = selectedCandidates.find(
            (selected) => selected.id === candidate.id
          );

          return (
            // <CandidateMapCard
            //   key={candidate.id}
            //   candidate={candidate}
            //   updateSelectedCandidates={updateSelectedCandidates}
            //   isSelected={!!selectedCandidate}
            //   selectedCandidate={selectedCandidate}
            //   selectedCandidates={selectedCandidates}
            //   MAX_CANDIDATES={MAX_CANDIDATES}
            //   setSelectedCandidates={setSelectedCandidates}
            // />

            <CandidateMapCard
              key={candidate.id}
              candidate={candidate}
              updateSelectedCandidates={updateSelectedCandidates}
              isSelected={selectedCandidates.some(
                (selected) => selected.id === candidate.id
              )}
              // isSelected={!!selectedCandidate}
              selectedCandidate={selectedCandidate}
              selectedCandidates={selectedCandidates}
              MAX_CANDIDATES={MAX_CANDIDATES}
              setSelectedCandidates={setSelectedCandidates}
            />
          );
        })}
        <Box
          sx={{
            textAlign: "right",
            marginTop: "20px",
            display: "flex",
            justifyContent: "right",
          }}
        >
          <Pagination
            count={pagination.total_pages}
            page={page}
            onChange={handlePageChange}
            color="primary"
          />
        </Box>
        {/* <Box>
          <h4>Selected Candidates Data:</h4>
          <pre>{JSON.stringify(selectedCandidates, null, 2)}</pre>
        </Box> */}
        <Box sx={{ marginTop: "20px", textAlign: "right" }}>
          <button
            onClick={handleOnClickApplyJob}
            style={{
              padding: "8px 20px",
              border: "none",
              borderRadius: "3px",
              cursor: "pointer",
              color: "#fff",
              backgroundColor: "rgb(56, 86, 166)",
            }}
            disabled={jobtimelineStatus === "loading"}
          >
            {jobtimelineStatus === "loading" ? "Loading" : "Confirm"}
          </button>
        </Box>
      </Offcanvas.Body>
    </Offcanvas>
  );
}

export default CandidateListApplyDrawer;
